import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${API_BASE_URL}/api` }),
  endpoints: (builder) => ({
    // Auth is the ONE mutation exception allowed through RTK Query.
    // All other POST/PATCH/DELETE ops go through direct Axios in components.
    login: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;
